import { QuestionType } from '@empathy/survey/base';

export const NotepadQuestionExcludedRender = [QuestionType.FileUpload, QuestionType.Heatmap];
